import type { ProvisionalSubmitValues } from './provisional-invoice-schema';

// Copies the single-line item (commodity) + payment term onto form values when
// present. Shared by the AI-extraction prefill and the edit-from-existing path.
export function applyItemAndTerm(
  values: Partial<ProvisionalSubmitValues>,
  source: { readonly item_description: string | null; readonly payment_term: string | null },
): void {
  if (source.item_description !== null) values.item_description = source.item_description;
  if (source.payment_term !== null) values.payment_term = source.payment_term;
}
